import { BranchPartnersDto } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/branch-partners-dto';

export interface IBranchCodesState {
  list: BranchPartnersDto[];
  loading: boolean;
}

export const initialUIState: IBranchCodesState = {
  list: [],
  loading: false,
};
